import ActionType from 'actions/ActionType'

export default (state = { address: 'none' }, action) => {
	switch (action.type) {
		case ActionType.Data.READ_SUCCESS:
			if (
				action.entityType === 'email/verify_my_address_status' &&
				action.payload?.address &&
				action.payload?.status === 'success'
			) {
				return {
					...action.payload,
					value: action.payload.address,
					label: action.payload.address,
					key: `${action.payload.address}SelectValue`,
				}
			} else if (
				action.entityType === 'email/verify_default_address_status' &&
				action.payload?.address &&
				action.payload?.status === 'success'
			) {
        return {
          ...action.payload,
          value: action.payload.address,
          label: action.payload.address,
          key: `${action.payload.address}SelectValue`,
        }
			}
			return state
		case ActionType.Inbox.SELECT_FROM_EMAIL:
			return action.payload
		default:
			return state
	}
}
